import { render, staticRenderFns } from "./BlogTwo.vue?vue&type=template&id=5af0ca9b&scoped=true&"
import script from "./BlogTwo.vue?vue&type=script&lang=js&"
export * from "./BlogTwo.vue?vue&type=script&lang=js&"
import style0 from "./BlogTwo.vue?vue&type=style&index=0&id=5af0ca9b&prod&lang=css&"
import style1 from "./BlogTwo.vue?vue&type=style&index=1&id=5af0ca9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0ca9b",
  null
  
)

export default component.exports